import { getContactUsListService } from "api/services/cmsServices";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import ContactUsTable from "./Components/ContactUsTable";

const ContactUsList = () => {
    const [list, setList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [paginationInfo, setPaginationInfo] = useState({
        totalPages: 1,
        hasNextPage: false,
        hasPrevPage: false,
    });

    useEffect(() => {
        getList(currentPage, limit);
    }, [currentPage, limit]);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handleLimitChange = (e) => {
        setLimit(parseInt(e.target.value));
        setCurrentPage(1); // Reset to page 1 when limit changes
    };

    const renderPageNumbers = () => {
        const pages = [];
        for (let i = 1; i <= paginationInfo.totalPages; i++) {
            pages.push(
                <button
                    key={i}
                    onClick={() => handlePageChange(i)}
                    className={`px-3 py-1 rounded border text-sm ${currentPage === i
                        ? "bg-blue-500 text-white"
                        : "bg-white text-gray-700 hover:bg-gray-100"
                        }`}
                >
                    {i}
                </button>
            );
        }
        return pages;
    };

    const getList = async (page = 1, limit = 10) => {
        try {
            const response = await getContactUsListService({
                page, limit
            });
            if (response.status === 200) {
                const { docs, totalPages, hasNextPage, hasPrevPage } = response.data?.data;
                setList(docs);
                setPaginationInfo({ totalPages, hasNextPage, hasPrevPage });
            }
        } catch (error) {
            toast.error("Failed to fetch data");
        }
    };

    return <div className="mt-4 flex w-full flex-col gap-5">

        <ContactUsTable tableData={list} callBack={() => getList(currentPage, limit)} />

        {/* Pagination Controls */}
        <div className="flex flex-col sm:flex-row justify-between items-center px-4 gap-3">
            {/* Limit Dropdown */}
            <div className="flex items-center gap-2">
                <label htmlFor="limit" className="dark:text-white text-sm">
                    Items per page:
                </label>
                <select
                    id="limit"
                    value={limit}
                    onChange={handleLimitChange}
                    className="px-2 py-1 border rounded text-sm"
                >
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                </select>
            </div>

            {/* Page Navigation */}
            <div className="flex items-center gap-2">
                <button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={!paginationInfo.hasPrevPage}
                    className="px-3 py-1 text-sm rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
                >
                    Previous
                </button>

                {renderPageNumbers()}

                <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={!paginationInfo.hasNextPage}
                    className="px-3 py-1 text-sm rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
                >
                    Next
                </button>
            </div>
        </div>

        {/* Current Page Info */}
        <div className="text-sm text-right px-4 text-gray-600">
            Showing page <strong>{currentPage}</strong> of{" "}
            <strong>{paginationInfo.totalPages}</strong>
        </div>
    </div>;
};

export default ContactUsList;
